<!-- <table mat-table [dataSource]=dataSource matSort class="mat-elevation-z8" (matSortChange)="sortData($event)"> -->
<div *ngIf="showHeader" [style.padding-top]="padding_top">
  <h5 *ngIf="title">{{ title }}</h5>
  <table  mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2" style="padding:'4px'">
    <ng-container *ngFor="let columnName of displayedColumns; let i = index" matColumnDef="{{ columnName }}">
      <!-- <th mat-header-cell *matHeaderCellDef [hidden]="showHeader" mat-sort-header></th> -->
      <th mat-header-cell  *matHeaderCellDef>
        <h6>{{ columnName | titlenamepipe }}</h6>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element[columnName] === true">
          <mat-icon>done</mat-icon></ng-container>
        <ng-container *ngIf="columnName === 'button'">
          <button 
            *ngIf="element[columnName] != null"
            mat-stroked-button
            (click)="go(element[columnName])"
          >
            {{ element[columnName].label }}
          </button>
        </ng-container>
        <ng-container *ngIf="columnName === 'html'">
          <div
            *ngIf="element[columnName] != null"
            [innerHTML]="element[columnName]"
          ></div>
        </ng-container>
        <ng-container *ngIf="element[columnName] === false"
          ><mat-icon>close</mat-icon></ng-container
        >
        <ng-container
          *ngIf="
            element[columnName] !== true &&
            element[columnName] !== false &&
            columnName !== 'button' &&
            columnName !== 'html'"
        >
          {{ element[columnName] }}
        </ng-container>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<!-- <mat-paginator [pageSizeOptions]="[5, 25, 50, 100]"></mat-paginator> -->


<!-- <table mat-table [dataSource]=dataSource matSort class="mat-elevation-z8" (matSortChange)="sortData($event)"> -->
  <div *ngIf="!showHeader" [style.padding-top]="padding_top">
    <h5 *ngIf="title">{{ title }}</h5>
    <table  mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2" style="padding:'3px'">
      <ng-container *ngFor="let columnName of displayedColumns; let i = index" matColumnDef="{{ columnName }}">
        <td mat-cell style="Border: 1px SOLID lightGray"    *matCellDef="let element">
          <ng-container *ngIf="element[columnName] === true">
            <mat-icon>done</mat-icon></ng-container>
          <ng-container *ngIf="columnName === 'button'">
            <button
              *ngIf="element[columnName] != null"
              mat-stroked-button
              (click)="go(element[columnName])"
            >
              {{ element[columnName].label }}
            </button>
          </ng-container>
          <ng-container *ngIf="columnName === 'html'">
            <div
              *ngIf="element[columnName] != null"
              [innerHTML]="element[columnName]"
            ></div>
          </ng-container>
          <ng-container *ngIf="element[columnName] === false"
            ><mat-icon>close</mat-icon></ng-container
          >
          <ng-container
            *ngIf="
              element[columnName] !== true &&
              element[columnName] !== false &&
              columnName !== 'button' &&
              columnName !== 'html'"
          >
            {{ element[columnName] }}
          </ng-container>
        </td>
      </ng-container>
      <tr mat-row   style="Border: 1px SOLID darkGray"    *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  
  
  
  
  
  
  </div>
  <!-- <mat-paginator [pageSizeOptions]="[5, 25, 50, 100]"></mat-paginator> -->
  


